import Banner from './Banner';
import Cta from './Cta';
import Features from './Features';
import Footer from './Footer';
import Header from './Header';
import Icons from './Icons';
import Spotlights from './Spotlights';
import Layout from './Layout';

export {
    Banner,
    Cta,
    Features,
    Footer,
    Header,
    Icons,
    Spotlights,
    Layout
};

export default {
    Banner,
    Cta,
    Features,
    Footer,
    Header,
    Icons,
    Spotlights,
    Layout
};
